enum chatAttachmentType {
  None,
  InternalImage,
  ExternalImage,
  YouTubeVideo,
  VimeoVideo,
  DailymotionVideo,
}

export default chatAttachmentType;
